import { CircularProgress } from "@mui/material";
import React, { useEffect, useRef } from "react";
import {
  IonContent,
  IonPage,
  useIonViewDidEnter,
  useIonViewWillEnter,
} from "@ionic/react";
import AddFamilyMember from "./components/AddFamilyMember";
import "./index.scss";
import FamilyProfileOverview from "./components/FamilyProfileOverview";
import FamilyProfile from "./components/FamilyProfile";
import BackButton from "../../components/common/BackButton";
import NoFamilyAdded from "./components/noFamilyAdded";
import FamilyDashboard from "./components/familyDashboard";
import DocumentContainer from "../documents/newIndexDoc";
import AddressBook from "../address/newIndexdummy";
import ErrorComponent from "../../components/common/ErrorComponent";
import {
  getFamilyData,
  getFamilyRelations,
  updateErrorState,
  updateLayout,
  updateLayoutAndLoading,
} from "./familySlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

export default function FamilyPlan() {
  const familyStore = useSelector((store) => store.familyInfo);

  const { ui, fetchingFamily, fetchingRelations } = familyStore;
  const { loading, error, errorMsg, layout, isData, isErrorPositive } = ui;
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const layoutRef = React.useRef(layout);
  const pageRef = useRef(null);
  const isPathHandledRef = useRef(false);

  React.useEffect(() => {
    layoutRef.current = layout;
  }, [layout]);

  useEffect(() => {
    dispatch(getFamilyData());
    dispatch(getFamilyRelations());
  }, []);

  useEffect(() => {
    if (fetchingFamily && fetchingRelations) {
      const { state } = location;
      if (state && state.isPath && !isPathHandledRef.current) {
        isPathHandledRef.current = true;
        dispatch(updateLayoutAndLoading({ layout: 4, loading: false }));
      } else {
        dispatch(
          updateLayoutAndLoading({
            layout: layout === 2 ? 2 : 1,
            loading: false,
          }),
        );
      }
    } else {
      if (!fetchingFamily) {
        dispatch(getFamilyData());
      }
      if (!fetchingRelations) {
        dispatch(getFamilyRelations());
      }
    }
  }, [fetchingFamily, fetchingRelations, dispatch]);

  useIonViewWillEnter(() => {
    if (pageRef.current) {
      pageRef.current.classList.remove("ion-page-hidden");
    }
  });

  useIonViewDidEnter(() => {
    isPathHandledRef.current = false;
    if (layoutRef.current !== 2) {
      dispatch(updateLayoutAndLoading({ layout: 1, loading: false }));
    }
  }, []);

  const handleErrorClose = () => {
    dispatch(updateErrorState({ data: false, msg: "" }));
  };

  const closeDialog = (isNewData = false, data) => {
    isPathHandledRef.current = true;
    dispatch(updateLayout(1));
    dispatch(getFamilyData());
  };

  return (
    <IonPage ref={pageRef}>
      <IonContent>
        {layout === 1 && (
          <div className="family-plan-container">
            <div className="family-plan-header">
              <BackButton></BackButton>
              <span>Family members</span>
            </div>
            {loading ? (
              <CircularProgress className="ion-router-circular-progress"></CircularProgress>
            ) : (
              <div className="family-plan-loaded">
                {isData ? <FamilyDashboard /> : <NoFamilyAdded />}
              </div>
            )}
          </div>
        )}
        {layout === 2 && (
          <FamilyProfileOverview
            editFamilyProfile={() => dispatch(updateLayout(3))}
          />
        )}
        {layout === 3 && <FamilyProfile closeDialog={closeDialog} />}
        {layout === 4 && <AddFamilyMember closeDialog={closeDialog} />}
        {layout === 5 && (
          <DocumentContainer
            inlineBack={() => dispatch(updateLayout(2))}
            inlineMemberData={ui.currentMember}
          />
        )}
        {layout === 6 && (
          <AddressBook
            inlineBack={() => dispatch(updateLayout(2))}
            inlineMemberData={ui.currentMember}
          />
        )}
        <ErrorComponent
          msg={errorMsg}
          show={error}
          isPositive={isErrorPositive}
          errorClose={handleErrorClose}
        />
      </IonContent>
    </IonPage>
  );
}
